import styled from '@emotion/styled';
import { BackIcon, typography } from '@sharefiledev/flow-web';

export const StyledCurrentItem = styled.div({
	display: 'flex',
	margin: '2px 2px 10px 0px',
	flex: '0 0 auto',
});

export const StyledCurrentItemName = styled.div({
	lineHeight: '20px',
	fontWeight: typography.weights.light,
});

export const StyledItemsContainer = styled.div({
	height: '290px',
	overflow: 'hidden',
	display: 'flex',
	flexDirection: 'column',
	paddingTop: '8px',
});

export const StyledItemList = styled.div({
	flexGrow: 1,
	overflow: 'auto',
	paddingTop: '5px',
});

export const StyledEmptyList = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	flexDirection: 'column',
});

export const StyledBackIcon = styled(BackIcon)({
	marginRight: '11px',
});
